import { useEffect } from 'react';
import { Button, SortDescriptor, useDisclosure } from '@ds';
import { AdminPageHeader, OnScreenLoader, SearchInputWithHistory } from '@ui';
import { MultiCaseSuggestTable, SelectCasesModal } from '@lp/features/MultiSuggest';
import { useInitialCaseFromParams } from '@lp/features/MultiSuggest/hooks';
import { useMultiSuggestionListQuery } from '@/queries/multi-suggest';
import { useFilterQueryWithParams } from '@/hooks/useFilterQueryWithParams';

export const DEFAULT_SORT_BY: SortDescriptor = {
  column: 'initiatedDate',
  direction: 'descending',
};

export const MultiCaseSuggest = () => {
  const { isOpen, onOpenChange, onOpen, onClose } = useDisclosure();
  const {
    data,
    isLoading,
    isFetching,
    page,
    itemsPerPage,
    searchText,
    sortBy,
    setPage,
    setItemsPerPage,
    setSearchText,
    setSortBy,
  } = useFilterQueryWithParams({
    filterList: {},
    defaultSortBy: DEFAULT_SORT_BY,
    query: useMultiSuggestionListQuery,
  });

  const { data: initialCaseParams } = useInitialCaseFromParams();

  useEffect(() => {
    if (initialCaseParams?.caseId && !isOpen) {
      onOpen();
    }
  }, [initialCaseParams, isOpen, onOpen]);

  return (
    <>
      <div className="flex flex-col grow place-items-stretch gap-4 p-6 bg-base-70">
        {!data && isLoading ? (
          <OnScreenLoader />
        ) : (
          <>
            <AdminPageHeader title="Multi-Case Suggestion">
              <div className="mr-4">
                <SearchInputWithHistory
                  handleSearch={setSearchText}
                  searchText={searchText}
                  storageKey="multiCaseSuggestHistory"
                />
              </div>
              <Button size="sm" onPress={onOpenChange}>
                Add New
              </Button>
            </AdminPageHeader>
            <div className="flex flex-col gap-4">
              <MultiCaseSuggestTable
                data={data?.items || []}
                page={page}
                itemsPerPage={itemsPerPage}
                sortBy={sortBy}
                isLoading={isLoading}
                isFetching={isFetching}
                totalItems={data?.totalItems || 0}
                totalPages={data?.totalPages || 1}
                setPage={setPage}
                setItemsPerPage={setItemsPerPage}
                setSortBy={setSortBy}
              />
            </div>
          </>
        )}
      </div>
      {isOpen && <SelectCasesModal isOpen={isOpen} onCloseModal={onClose} />}
    </>
  );
};
